import { useDispatch, useSelector } from 'react-redux'
import { FlashList } from "@shopify/flash-list";
import * as XLSX from "xlsx"
import Preferance from '../constants/Preferances';

import { ActivityIndicator, SafeAreaView, View, StyleSheet, ScrollView, SectionList, Dimensions, Touchable, TouchableOpacity, Linking, Alert } from 'react-native';
import { Text, IconButton, Button, FAB, shadow, TextInput, Chip } from 'react-native-paper';

import * as React from 'react';
import DYear from '../components/DYear';
import { useTheme } from 'react-native-paper';
import NotificationRow from '../components/NotificationRow';
import ReactNativeModal from 'react-native-modal';
import { collection, doc, getFirestore, onSnapshot, query, setDoc, updateDoc, where } from 'firebase/firestore';
import Toast from 'react-native-root-toast';
import StudentPlainRow from '../components/StudentRowPlain';
import dayjs from 'dayjs';
import * as Share from 'expo-sharing';
import DImage from '../components/DImage';
import Global from '../constants/global';
import DIcon from '../components/DIcon';
import DModal from '../components/DModal';
import { listsTask } from '../task/listTasks';
import { SortBy } from 'expo-media-library';
const cy = Global.getYear()

let remover: [] = []
let baselist: [] = []
export default function StudentList({ navigation, route }) {
    const bhudevList = useSelector(React.useMemo(Global.getUserList, []))
    const classes = useSelector((state) => state.list.Classes)
    const [alllist, setAllList] = React.useState({ baselist: [], class: {}, list: [], sortedClasses: [] })
    const [show, setShow] = React.useState(false)
    const [currentYear, setCY] = React.useState(cy)


    const pref = React.useContext(Preferance)


    React.useEffect(() => {
        const a = []
        baselist = bhudevList.map(e => {
            a.push({ ...e })
        })
        // const nnewP = a.sort((a, b) => a?.roll < b?.roll ? -1 : 0)
        setAllList(p => ({ ...p, baselist: a }))
        if (alllist.class?.id) {
            updateClassList(a)
        }
        // //console.log("coming here", nnewP)
    }, [bhudevList]);

    React.useEffect(() => {
        if (classes) {
            const s: [] = []
            // this is new class system classes are same every year
            classes.map(p => {
                if (p.final == true) {
                    s.push({ ...p })
                }
            })
            const nnewP = s.sort((a, b) => a?.seq < b?.seq ? -1 : 0)
            setAllList(p => ({ ...p, sortedClasses: nnewP }))
        }
    }, [classes, currentYear])

    function updateClassList(blint) {
        const bslist = blint ? blint : []
        // //console.log("bslist", bslist)
        const l = bslist.filter(st => st["class" + currentYear]?.classId == alllist.class.id)
        const l1 = l.sort((a, b) => a["class" + currentYear]?.roll < b["class" + currentYear]?.roll ? -1 : 0)
        // //console.log("coming here l1", l1, alllist.class.id)
        setAllList(p => ({ ...p, list: l1 }))
    }




    const { colors } = useTheme();
    return (
        <View style={{ backgroundColor: colors.background, flex: 1 }}>
            <View style={{ backgroundColor: "white", alignSelf: "stretch" }}>
                <DImage width={170} uri="https://i.pinimg.com/564x/d2/57/67/d257676b21bfdda5ca88d3b7e4b54d87.jpg" />
            </View>

            <View style={{ flexDirection: "row", flexWrap: "wrap", justifyContent: "center" }}>
                <TouchableOpacity onPress={() => { setShow(true) }}>
                    <View style={{ flexDirection: "row", alignItems: "center" }}>
                        <Text>{Global.getYearString(currentYear)}</Text>
                        <DIcon name="cog" color='black' />
                    </View>
                </TouchableOpacity>

                {
                    alllist.sortedClasses.map(e => {
                        return <Chip style={{ margin: 2 }} selected={e == alllist.class} onPress={() => setAllList(p => ({ ...p, class: e }))}>{e.name + (e.div ? " " + e.div : "")}</Chip>
                    })
                }
            </View>
            {/* <Button onPress={() => {
                alllist.baselist.map(f=>{
                    const l =bhudevList.filter(e=> e.name == f.name)
                    if (l.length > 1){
                        //console.log(f.name,l.length)
                    }
                })
            }}>Chck</Button> */}
            <ClassWiseStudent pref={pref} year={currentYear} colors={colors} navigation={navigation} cl={alllist.class} />

            < FAB
                icon="plus"
                style={{
                    position: 'absolute',
                    margin: 16,
                    right: 0,
                    bottom: 0,
                }}
                onPress={() => {
                    if (alllist.class.id) {
                        navigation.navigate("NewStudent",
                            { data: { bday: dayjs().unix(), classId: alllist.class.id, class: alllist.class.name }, classId: alllist.class.id, class: alllist.class.name })
                    } else {
                        alert("Please select class first")
                    }
                }

                }
            />

            <DYear show={show} year={currentYear} close={() => {
                setShow(false)
            }} change={(yr) => {
                setCY(yr)
                setAllList(p => ({ ...p, list: [] }))
                setShow(false)
            }} />

        </View >
    );


}

const ClassWiseStudent = ({ year, colors, navigation, cl, pref }) => {
    const [list, setList] = React.useState([])
    const clist = useSelector(s => s.list.Students)
    const [wait, setWait] = React.useState(false)
    const dispatch = useDispatch()
    React.useEffect(() => {
        // //console.log("clist", clist)
        let l = []
        if (clist) {
            clist.map(r => {
                // //console.log(r["class" + year]?.classId, cl, r["class" + year]?.classId == cl)
                if (r["class" + year]?.classId == cl.id) {
                    if (r?.flag && r?.flag == -10) {

                    } else {
                        l.push({ ...r })
                    }
                }
            })
            // //console.log("list l", l)
            l = Global.sortStudent(l, year)
            // //console.log("list l1", l1)

        }
        setList(l)

    }, [clist])

    React.useEffect(() => {
        let s
        if (year && cl?.id) {
            // //console.log("fetching year", year, cl)
            setWait(true)
            const db = getFirestore()
            const citiesRef = collection(db, Global.STUDENTS);
            let q = query(citiesRef, where("class" + year + ".classId", "==", cl.id));


            // //console.log("Fetch called") 

            s = onSnapshot(q, { includeMetadataChanges: true },
                (docc) => {
                    let tklist: [] = []
                    let del = []
                    docc.docChanges().forEach((change) => {
                        const d = change.doc.data()
                        if (change.type === "removed") {
                            // del.push(d)
                            dispatch(listsTask.actions.remove({ type: Global.STUDENTS, data: change.doc.data(), refresh: true }))
                        } else {
                            tklist.push({ data: d })
                        }
                    });

                    // //console.log("Fetch ", tklist)
                    dispatch(listsTask.actions.updateActivity({ type: Global.STUDENTS, data: tklist, isArray: true, refresh: true }))
                    setWait(false)
                });
            remover.push(s)
        }
        return () => {
            // //console.log("cleanup", s)
            if (s) {
                try {
                    //console.log("cleanupdone")
                    s()
                } catch { }
            }
        }
    }, [year, cl])
    //console.log(pref)
    return wait ? <ActivityIndicator animating /> : <View>
        <FlashList
            data={list}
            key="id"
            estimatedItemSize={50}
            contentContainerStyle={{ backgroundColor: "transparent" }}
            keyboardShouldPersistTaps={'handled'}
            renderItem={({ item, index }) =>
                <StudentRow item={item} year={year} colors={colors} navigation={navigation}  pref={pref}/>
            } />
        {(pref?.current.supervisor == true || pref?.current.type == 0) && <FAB
            icon="download"
            style={{
                position: 'absolute',
                margin: 16,
                right: 0,
                bottom: 60,
            }}
            onPress={() => {
                const workbook = XLSX.utils.book_new();
                const headers = ["Roll", "Left", "Name", "GR No", "UID", "Address", "Mobile", "Birth Day"]
                const bslist = list
                ////console.log("bslist", bslist)
                const l = bslist.filter(st => st["class" + year]?.classId == cl.id)
                const l1 = l.sort((a, b) => a.roll < b.roll ? -1 : 0)
                const l2: [] = []
                l1.map(st => {
                    const s = st["class" + year]
                    let b = ""
                    if (s?.bday) {
                        b = dayjs.unix(s?.bday).format("DD/MM/YYYY")
                    }
                    const lf = Global.isLeft(st, year) == true ? "Yes" : ""
                    l2.push({ roll: s.roll, left: lf, name: st.name, gr: s.gr, uid: st.uid, address: st.address, mobile: st.mobile, bday: b })
                })
                const worksheet = XLSX.utils.json_to_sheet(l2)
                //                        //console.log(l2)
                const nm = cl.name + (cl.div ? " " + cl.div : "")
                XLSX.utils.book_append_sheet(workbook, worksheet, nm);
                XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });
                XLSX.writeFile(workbook, "StudentRecord" + nm + ".xlsx");
            }
            }
        />}


    </View>


}

async function delStudent(id) {
    if (id) {
        const db = getFirestore()
        const d = doc(db, Global.STUDENTS, id)
        try {
            if (d) {
                await setDoc(d, { flag: -10 }, { merge: true })
                Toast.show("Deleted")
                return true
            } else {
                Toast.show("Error ref id missing")
            }
        } catch {
            return false

        }
    } else {
        Toast.show("Error No id found")
    }

}
async function left(student, year) {
    if (student.id) {
        const db = getFirestore()
        const d = doc(db, Global.STUDENTS, student.id)
        const nst = student.left ? false : true

        try {
            if (d) {

                updateDoc(d, { [`class${year}.left`]: nst }, { merge: true }).then(e => {
                    alert("Done")
                    Toast.show("Done")

                })
            } else {
                Toast.show("Error ref id missing")
            }
        } catch {
            return false

        }
    } else {
        Toast.show("Error No id found")
    }

}

const StudentRow = ({ item, year, navigation, colors, pref }) => {
    const [options, setOptions] = React.useState(false)
    const [deletConf, setDeletConf] = React.useState(undefined)
    return <><TouchableOpacity onPress={() => setOptions(true)}>
        <StudentPlainRow info={item} withGr={true} withStream={true} currentYear={year} />
    </TouchableOpacity>
        < ReactNativeModal
            isVisible={options}
            onBackdropPress={() => setOptions(false)}
            onDismiss={() => setOptions(false)}
            style={{ margin: 0, position: "absolute", bottom: 0, width: Dimensions.get("window").width }} animationIn="slideInUp" >

            <View style={{ backgroundColor: colors.surface }}>
                <View style={{ justifyContent: "center" }}>
                    <Text variant="titleLarge" style={{ padding: 13, fontWeight: "bold", flex: 1 }}>{item?.name}...</Text>
                    {item?.mobile &&
                        <View style={{ flexDirection: "row", alignItems: "center", backgroundColor: "transparent" }}>
                            <TouchableOpacity style={{ flex: 1 }} onPress={() => { Linking.openURL('tel:' + item?.mobile); setOptions(false) }} >
                                <View style={{ flexDirection: "row", alignItems: "center", flex: 1 }}>
                                    <IconButton style={{ marginLeft: 10, marginRight: 10 }} icon="phone-outgoing" />
                                    <Text style={{ paddingLeft: 10, paddingRight: 10 }} >{"Mobile -"} ({item?.mobile})</Text>
                                </View>
                            </TouchableOpacity>
                            <IconButton style={{ marginLeft: 10, marginRight: 10 }} icon="whatsapp" onPress={() => { Share.shareAsync({ title: "નમસ્કાર", "message": "આપનો દિવસ શુભ રહે 🙂" }) }} />
                        </View>
                    }
                    <TouchableOpacity onPress={() => {
                        setOptions(false);
                        navigation.navigate("NewStudent", { data: item })
                    }}>
                        <View style={{ flexDirection: "row", alignItems: "center", backgroundColor: "transparent" }}>
                            <IconButton style={{ marginLeft: 10, marginRight: 10 }} icon="lead-pencil" />
                            <Text style={{ paddingLeft: 10, paddingRight: 10 }} >Edit</Text>
                        </View>
                    </TouchableOpacity>
                    <TouchableOpacity onPress={() => {
                        setOptions(false);
                        left(item, year)
                    }}>
                        <View style={{ flexDirection: "row", alignItems: "center", backgroundColor: "transparent" }}>
                            <IconButton style={{ marginLeft: 10, marginRight: 10 }} icon="account-off" />
                            <Text style={{ paddingLeft: 10, paddingRight: 10 }} >Mark as {item?.left == true ? "Not Left" : "Left"}</Text>
                        </View>
                    </TouchableOpacity>

                    {pref?.current.type == Global.PRINCIPAL && <TouchableOpacity onPress={() => { setDeletConf(item.id); setOptions(false) }}>
                        <View style={{ flexDirection: "row", alignItems: "center", backgroundColor: "transparent" }}>
                            <IconButton style={{ marginLeft: 10, marginRight: 10 }} icon="delete" />
                            <Text style={{ paddingLeft: 10, paddingRight: 10 }} >Delete</Text>
                        </View>
                    </TouchableOpacity>}
                </View>
                <IconButton icon={"window-close"} onPress={() => setOptions(false)} style={{ position: "absolute", top: 0, right: 0 }} />
            </View>
        </ReactNativeModal>
        < ReactNativeModal
            isVisible={deletConf !== undefined}
            onBackdropPress={() => setDeletConf(undefined)}
            onDismiss={() => setDeletConf(undefined)}
            style={{ margin: 0, position: "absolute", bottom: 0, width: Dimensions.get("window").width }} animationIn="slideInUp" >

            <View style={{ backgroundColor: colors.surface }}>
                <View style={{ justifyContent: "center" }}>
                    <Text variant="titleLarge" style={{ padding: 13, fontWeight: "bold", flex: 1 }}>{deletConf?.name}...</Text>
                    <Text style={{ padding: 13, fontWeight: "bold", flex: 1 }}>Are you sure ? All Student's data including his result data will be removed </Text>
                    <View style={{ flexDirection: "row" }}>
                        <Button onPress={() => setDeletConf(undefined)} style={{ flex: 1 }}>Cancel</Button>
                        <Button onPress={() => { delStudent(item.id) }} mode="contained" style={{ flex: 1 }}>Delete</Button>
                    </View>

                </View>
                <IconButton icon={"window-close"} onPress={() => setDeletConf(undefined)} style={{ position: "absolute", top: 0, right: 0 }} />
            </View>
        </ReactNativeModal>

    </>


}
